export const TRIPADVISOR_RATING = '4.9';
export const TRIPADVISOR_REVIEW_COUNT = 35;
